// extracted by mini-css-extract-plugin
module.exports = {"title":"SmallSliderItem_title__2dwb5","text":"SmallSliderItem_text__3IsTR","img":"SmallSliderItem_img__tKnm6"};